import React, { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import FemsAPP from "../fems/FemsAPP";
import { FxmsData } from "./../fxms/datas/FxData";
import { FxUiData } from "./../fxms/datas/FxUiData";
import FxAppBar from "./../fxms/components/FxAppBar";
import { FxMenuList } from "./../fxms/components/FxMenuList";
import { FxContentBox } from "./../fxms/components/FxContentBox";
import * as authAction from "../fxms/jwt/auth-action";
import { VupData } from "./datas/VupData";
import { VupDash } from "./VupDash";
import { PlantDash } from "./PlantDash";
import { VupComplexDash } from "./VupComplexDash";
import { VupPlantDash } from "./VupPlantDash";
import { UI_0_2 } from "./ui/UI_0_2";
import { UI_1_1 } from "./ui/UI_1_1";
import { UI_1_2 } from "./ui/UI_1_2";
import { UI_1_4 } from "./ui/UI_1_4";
import { UI_1_5 } from "./ui/UI_1_5";
import { UI_1_6 } from "./ui/UI_1_6";
import { UI_2_1 } from "./ui/UI_2_1";
import { UI_2_2 } from "./ui/UI_2_2";
import { UI_2_3 } from "./ui/UI_2_3";
import { UI_3_1 } from "./ui/UI_3_1";
import { UI_3_1_CU } from "./ui/UI_3_1_CU";
import { UI_3_3 } from "./ui/UI_3_3";
import { UI_3_3_CU } from "./ui/UI_3_3_CU";
import { UI_3_4 } from "./ui/UI_3_4";
import { UI_3_5 } from "./ui/UI_3_5";
import { UI_4_3_CU } from "./ui/UI_4_3_CU";
import { UI_4_7_CU } from "./ui/UI_4_7_CU";
import { UI_5_3 } from "./ui/UI_5_3";
import { UI_5_3_CU } from "./ui/UI_5_3_CU";
import { UI_5_4 } from "./ui/UI_5_4";
import { UI_5_4_CU } from "./ui/UI_5_4_CU";
import { UI_5_5 } from "./ui/UI_5_5";
import { UI_5_6 } from "./ui/UI_5_6";
import { UI_6_1 } from "./ui/UI_6_1";
import { UI_6_2 } from "./ui/UI_6_2";
import { UI_6_3 } from "./ui/UI_6_3";
import { UI_8_1_CU } from "./ui/UI_8_1_CU";
import { UI_MyInfo_CU } from "./ui/UI-MyInfo-CU";
import { UI_SignUp_CU } from "./ui/UI_SignUp_CU";
import { UI_Board_CU } from "./ui/UI_Board_CU";
import { FxMoPopup } from "./../fxms/components/mo/FxMoPopup";
import { FxMoChartPopup } from "./../fxms/components/mo/FxMoChartPopup";
import { VupAdminDash } from "./VupAdminDash";
import { VupComDash } from "./VupComDash";
import { MyError } from "../_sample/layout/MyError";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { PlantDashJohab } from "./PlantDashJohab";
import { Monitoring } from "./Monitoring";
import { WeatherInfo } from "./components/WeatherInfo";
//import OAuth2RedirectHandler from "./OAuth2RedirectHandler";

let logoutTimer;

const VUPApp = (props) => {
  const [appItem, setAppItem] = React.useState({
    opObj: FxmsData.getOpObj("comp-app-bar"),
  });
  const [menuItem, setMenuItem] = React.useState({
    opObj: FxmsData.getOpObj("comp-menu-list"),
  });
  const [defResource, setDefResource] = React.useState(null);
  const [uiGrpNo, setUiGrpNo] = React.useState(-1);
  const [userGrpNo, setUserGrpNo] = React.useState();
  const [init, setInit] = React.useState(false);
  const h2Value = useSelector((state) => state.H2.value);

  const user = FxmsData.getUser();

  const [drawerOpen, setDrawerOpen] = React.useState(true);
  const [leftHeight, setLeftHeight] = React.useState(0);
  const rightRef = React.useRef(null);

  useEffect(() => {
    if (!init) return; // init이 true일 때만 실행

    const handleResize = () => {
      if (rightRef.current) {
        const totalHeight = rightRef.current.scrollHeight;
        setLeftHeight(totalHeight);
      }
    };
  
    window.addEventListener('resize', handleResize);
  
    // topBar가 렌더링된 후에만 실행
    setTimeout(handleResize, 0);
  
    return () => window.removeEventListener('resize', handleResize);
  }, [init]);

  useEffect(() => {
    // VUP 전용 컴포넌트 추가
    FxUiData.addComp("VupDash", VupDash); // 기존 VUP대시보드 23.3.29 기준 미사용
    FxUiData.addComp("VupAdminDash", VupAdminDash); // 새로 추가된 총괄대시보드
    FxUiData.addComp("VupComplexDash", VupComplexDash);
    //FxUiData.addComp("PlantDash", PlantDash);
    FxUiData.addComp("VupPlantDash", PlantDash);
    FxUiData.addComp("ui-0-2", UI_0_2);
    FxUiData.addComp("ui-1-1", UI_1_1);
    FxUiData.addComp("ui-1-2", UI_1_2);
    FxUiData.addComp("ui-1-4", UI_1_4);
    FxUiData.addComp("ui-1-5", UI_1_5);
    FxUiData.addComp("ui-1-6", UI_1_6);
    FxUiData.addComp("ui-2-1", UI_2_1);
    FxUiData.addComp("ui-2-2", UI_2_2);
    FxUiData.addComp("ui-2-3", UI_2_3);
    FxUiData.addComp("ui-3-1", UI_3_1);
    FxUiData.addComp("ui-3-1-detail", UI_3_1_CU);
    FxUiData.addComp("ui-3-3", UI_3_3);
    FxUiData.addComp("ui-3-3-add", UI_3_3_CU);
    FxUiData.addComp("ui-3-3-edit", UI_3_3_CU);
    FxUiData.addComp("ui-3-4", UI_3_4);
    FxUiData.addComp("ui-3-5", UI_3_5);
    FxUiData.addComp("ui-4-3-add", UI_4_3_CU);
    FxUiData.addComp("ui-4-3-edit", UI_4_3_CU);
    FxUiData.addComp("ui-4-7-add", UI_4_7_CU);
    //FxUiData.addComp("ui-user-new-apply", UI_SignUp_CU);
    FxUiData.addComp("ui-4-7-edit", UI_4_7_CU);
    FxUiData.addComp("VupComDash", VupComDash);
    FxUiData.addComp("ui-4-2-detail", FxMoPopup);
    FxUiData.addComp("ui-4-2-value-detail", FxMoChartPopup);
    FxUiData.addComp("ui-5-3", UI_5_3);
    FxUiData.addComp("ui-5-3-edit", UI_5_3_CU);
    FxUiData.addComp("ui-5-4", UI_5_4);
    FxUiData.addComp("ui-5-4-detail", UI_5_4_CU);
    FxUiData.addComp("ui-5-5", UI_5_5);
    FxUiData.addComp("ui-5-6", UI_5_6);
    FxUiData.addComp("ui-6-1", UI_6_1);
    FxUiData.addComp("ui-6-2", UI_6_2);
    FxUiData.addComp("ui-6-3", UI_6_3);
    FxUiData.addComp("ui-8-1-add", UI_8_1_CU);
    FxUiData.addComp("ui-8-1-detail", UI_8_1_CU);
    FxUiData.addComp("ui-my-info-edit", UI_MyInfo_CU);
    FxUiData.addComp("ui-board-add", UI_Board_CU);
    FxUiData.addComp("ui-board-detail", UI_Board_CU);
    //FxUiData.addComp("ui-user-new-apply", UI_SignUp_CU);

    // 로그인한 사용자의 설치위치 정보를 확인하여
    // 총괄, 산단, 공단 대시보드로 이동한다.
    const inlo = FxmsData.getInlo(user.inloNo);

    const title = (inlo ? inlo?.inloName : user?.inloName) + " (VUP)";

    if (user.inloClCd === "PROJECT") {
      //setDefResource(<VupDash />);
      setDefResource(<VupAdminDash />);
    } else if (user.inloClCd === "COMPLEX") {
      FxmsData.setVarValue("ui-title", title);
      setDefResource(<VupComDash complexInloNo={user.inloNo} />);
    } else if (user.inloClCd === "PLANT" || user.inloClCd === "COMPANY") {
      localStorage.setItem("plantInfoJson", JSON.stringify(inlo));
      FxmsData.setVarValue("ui-title", title);
      setDefResource(<PlantDash />);
    } else if (user.inloClCd === "FXMS") {
      try {
        setUiGrpNo(Number(localStorage.getItem("basUiGrpNo")));
        setUserGrpNo(user.ugrpNo);
      } catch (error) {
        //setDefResource(<VupDash />);
        setDefResource(<VupAdminDash />);
      }
    }

    VupData.initData(function (obj) {
      setInit(true);

      console.log("*** USER ***********************************");
      console.log("user", user);
      console.log("uiGrpNo", uiGrpNo);
      console.log("userGrpNo", user.ugrpNo);
      console.log("initData", obj);
      console.log("********************************************");
    });
  }, []);

  const logoutHandler = useCallback(() => {
    authAction.logoutActionHandler();
    FxmsData.logout();

    if (logoutTimer) {
      clearTimeout(logoutTimer);
    }
  }, []);

  // logoutTimer = setTimeout(
  //   logoutHandler,
  //   localStorage.getItem("remainingTime")
  // );

  console.log("*** VUPApp ***  uiGrpNo = ", uiGrpNo);
  console.log("*** VUPApp *** init = ", init);

  console.log("*** VUPApp ***  userGrpNo = ", userGrpNo);

  if (init === false) {
    return "";
  }

  return (
    <>
      {uiGrpNo >= 0 ? (
        <FemsAPP uiGrpNo={uiGrpNo} userGrpNo={userGrpNo} />
      ) : (
        <>
          <FemsAPP />
          <BrowserRouter>
            <div className="VUPTop" >
              <FxAppBar fxUiGrpItem={appItem} userGrpNo={userGrpNo} onMenuClick={() => setDrawerOpen(!drawerOpen)}/>
            </div>
            <div className="VUPContent">
              <div className={`VUPContentLeft ${drawerOpen ? '' : ' hidden'}`} style={{ height: leftHeight }}>
                <FxMenuList />
                <WeatherInfo />
              </div>
              <div className="VUPContentRight"  ref={rightRef}>
                <FxContentBox>
                  <Routes>
                    <Route path="/" element={defResource} />
                    <Route path="/comp-vup-dash" element={<VupAdminDash />} />
                    <Route
                      path="/comp-vup-complex-dash/:complexInloNo"
                      element={<VupComDash complexInloNo={user.inloNo} />}
                    />
                    <Route
                      path="/comp-vup-plant-dash/:plantInloNo"
                      element={<PlantDash plantInloNo={user.inloNo} />}
                    />
                    <Route
                      path="/comp-vup-johab-plant-dash/:plantInloNo"
                      element={<PlantDashJohab plantInloNo={user.inloNo} />}
                    />
                    {/* <Route
                      path="/oauth2/callback"
                      component={OAuth2RedirectHandler}
                    ></Route> */}
                    <Route path="/monitoring" element={<Monitoring />}></Route>
                    <Route path="*" element={<MyError />}></Route>
                  </Routes>
                </FxContentBox>
              </div>
            </div>
          </BrowserRouter>
        </>
      )}
    </>
  );
};

export default VUPApp;
